<main id="main" class="main">
  <section class="section dashboard">
    <!-- Header -->
    <div class="row">
      <div class="col-md-12">
        <h6 class="admintitle">
          Receivables&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
      </div>
    </div>

    <!-- Payment Method Blocks -->
<div class="row justify-content-center g-0" style="margin-top:2px;">
  <div class="col-md-2 p-0" (click)="selectPaymentType('credit')" style="cursor: pointer;">
    <div class="card text-center">
      <h6 [ngClass]="['block', selectedPaymentType === 'credit' ? 'active' : '']" class="mb-0">Credit Card</h6>
    </div>
  </div>

  <div class="col-md-2 p-0" (click)="selectPaymentType('pad')" style="cursor: pointer;">
    <div class="card text-center">
      <h6 [ngClass]="['block', selectedPaymentType === 'pad' ? 'active' : '']" class="mb-0">PAD</h6>
    </div>
  </div>

  <div class="col-md-2 p-0" (click)="selectPaymentType('eft')" style="cursor: pointer;">
    <div class="card text-center">
      <h6 [ngClass]="['block', selectedPaymentType === 'eft' ? 'active' : '']" class="mb-0">EFT</h6>
    </div>
  </div>
</div>

    <!-- Table & Pagination Section -->
    
    <div *ngIf="selectedPaymentType" class="mt-2">
    
     
  <div class="row align-items-end g-2 mb-3">

  <!-- Filter By Label -->
  <div class="col-auto">
    <label class="form-label mb-0">Filter By:</label>
  </div>

  <!-- Month/Range radio + input -->
  <div class="col-md-2">
    <div class="d-flex gap-2 mb-1">
      <div class="form-check form-check-inline mb-0">
        <input
          class="form-check-input"
          type="radio"
          id="filterMonth"
          name="filterIsMonthRange"
          [value]="false"
          [(ngModel)]="filterIsMonthRange"
          (change)="onRangeChange()"
        />
        <label class="form-check-label" for="filterMonth">Month</label>
      </div>
      <div class="form-check form-check-inline mb-0">
        <input
          class="form-check-input"
          type="radio"
          id="filterRange"
          name="filterIsMonthRange"
          [value]="true"
          [(ngModel)]="filterIsMonthRange"
          (change)="onRangeChange()"
        />
        <label class="form-check-label" for="filterRange">Range</label>
      </div>
    </div>

    <!-- Conditional date input -->
    <div>
      <ng-container *ngIf="filterIsMonthRange; else monthInput">
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Select Range"
          bsDaterangepicker
          [(ngModel)]="filterDateSelection"
          (ngModelChange)="applyFilters()"
          [bsConfig]="{
            rangeInputFormat: 'MMM YYYY',
            minMode: 'month',
            showWeekNumbers: false
          }"
          [maxDate]="maxDateForPicker"
          [minDate]="minDateForPicker"
        />
      </ng-container>

      <ng-template #monthInput>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Select Month"
          bsDatepicker
          [(ngModel)]="filterDateSelection"
          (ngModelChange)="applyFilters()"
          [bsConfig]="{
            dateInputFormat: 'MMM YYYY',
            minMode: 'month',
            showWeekNumbers: false
          }"
          [maxDate]="maxDateForPicker"
          [minDate]="minDateForPicker"
        />
      </ng-template>
    </div>
  </div>

  <!-- IGBMS ID -->
  <div class="col-md-1">
     <label class="form-check-label" for="filterMonth">IGBMS ID</label>
    <input
      type="text"
      class="form-control form-control-sm"
      placeholder="IGBMS ID"
      [(ngModel)]="filterIgbmsId"
      (ngModelChange)="applyFilters()"
    />
    
  </div>

  <!-- Auth ID -->
  <div class="col-md-1">
     <label class="form-check-label" for="filterMonth">Auth ID</label>
    <input
      type="text"
      class="form-control form-control-sm"
      placeholder="Auth ID"
      [(ngModel)]="filterAuthId"
      (ngModelChange)="applyFilters()"
    />
  </div>

  <!-- Status dropdown -->
<div class="col-md-1">
  <div class="dropdown">
    <label class="form-check-label">Status</label>
    <button
      class="btn btn-sm btn-outline-secondary dropdown-toggle w-100 text-start"
      type="button"
      data-bs-toggle="dropdown"
    >
      {{ selectedStatuses.length ? selectedStatuses.join(', ') : 'Status' }}
    </button>
    <ul class="dropdown-menu w-100 p-2" style="max-height: 200px; overflow-y: auto;">
     <li *ngFor="let status of statusOptions" class="dropdown-item p-0">
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      [id]="'status_' + status"
      [value]="status"
      [checked]="selectedStatuses.includes(status)"
      (change)="onStatusChange($event)"
    />
    <label class="form-check-label" [for]="'status_' + status">{{ status | titlecase }}</label>
  </div>
</li>

    </ul>
  </div>
</div>


</div>


      <!-- CREDIT TABLE -->
  
<div class="d-flex justify-content-between align-items-center">
  
  <div id="DataTables_Table_0_length"></div>
 
</div>

<!-- Table -->
 <div class="model-body linescrollbar" style="overflow-y: auto;position:relative;">
  <div style="position:absolute;left:200px;top:10px;">
  <img
      src="assets/img/download_list.png"
      alt="Download"
      class="download-list"
      *ngIf="filteredData?.length > 0" 
      style="height: 28px; cursor: pointer;"
      (click)="downloadArrears()"
      title="Download Receivables"
    />
    </div>
 
<div class="table-responsive mt-2" style="margin-bottom: 48px;">
  <table
    datatable
    [dtOptions]="dtOptions"
    [dtTrigger]="dtTrigger"
    class="table text-nowrap"
    *ngIf="selectedPaymentType"
  >
    <thead>
      <tr>
        <th>IGBMS ID</th>
        <th>Auth ID</th>
        <th>Stax ID</th>
        <th>Member Name</th>
        <th>Company</th>
        <th class="text-end">Amount</th>
        <th>Invoice No</th>
        <th>Due Date</th>
        <th>Pmt Platform</th>
        <th>Status</th>
        <th>History</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of filteredData">
        <td>{{ item.customerId }}</td>
        <td>{{ item.authorizenetCustomerId }}</td>
        <td>{{ item.fusebillCustomerId }}</td>
        <td>{{ item.firstName }} {{ item.lastName }}</td>
        <td>{{ item.companyName }}</td>
        <td class="text-end" style="padding-right:15px !important">{{ item.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
        <!-- <td><a href="#" class="text-decoration-underline">{{ item.invoiceNumber }}</a></td> -->
        <td>
  <a (click)="openInvoice(item.invoiceNumber)" class="text-decoration-underline" style="cursor:pointer;">
    {{ item.invoiceNumber }}
  </a>
</td>

        <td>{{ item.dueDate | date: 'MM/dd/yyyy' }}</td>
        <td>{{ item.paymentPlatform }}</td>
        <td>{{ item.paymentStatus }}</td>
        <td>
  <button
    class="btn btn-sm btn-outline-primary"
    data-bs-toggle="modal"
    data-bs-target="#historyModal"
    (click)="viewHistory(item)"
  >
    View
  </button>
</td>

        <td><!-- Action buttons --></td>
      </tr>
    </tbody>
  </table>
</div>
</div>


    </div>

    
  

  </section>
</main>

<!-- History Modal -->
<div
  id="historyModal"
  class="modal fade modalposition modal-lg my-custom-modal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="static"
  style="max-width: 100% !important;"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">Payment History</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body linescrollbar" style="overflow-y: auto;">
        <div *ngIf="selectedItem">


<div *ngIf="selectedHistory?.length > 0">
  <!-- <h6 class="fw-bold mt-3">Payment History</h6> -->
  <table class="table table-bordered table-sm text-nowrap mt-2">
    <thead>
      <tr>
        <th>IGBMS ID</th>
        <th>Auth ID</th>
        <th>Stax ID</th>
        <th>Member Name</th>
        <th>Company</th>
        <th>Amount</th>
        <th>Statement Balance</th>
        <th>Invoice No</th>
        <th>Due Date</th>
        <th>Created</th>
        <th>Modified</th>
        <th>Payment Method</th>
        <th>Platform</th>
        <th>Status</th>
        <!-- <th>Specific Status</th> -->
        <!-- <th>Reference</th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let h of selectedHistory">
        <td>{{ h.customerId }}</td>
        <td>{{ h.authorizenetCustomerId }}</td>
        <td>{{ h.fusebillCustomerId }}</td>
        <td>{{ h.firstName }} {{ h.lastName }}</td>
        <td>{{ h.companyName }}</td>
        <td>{{ h.amount | currency:'USD' }}</td>
        <td>{{ h.statementBalance | currency:'USD' }}</td>
        <td>{{ h.invoiceNumber }}</td>
        <td>{{ h.dueDate | date: 'MM/dd/yyyy' }}</td>
        <td>{{ h.created | date: 'short' }}</td>
        <td>{{ h.modified | date: 'short' }}</td>
        <td>{{ h.paymentMethod }}</td>
        <td>{{ h.paymentPlatform }}</td>
        <td>{{ h.paymentStatus }}</td>
        <!-- <td>{{ h.specificStatus }}</td> -->
        <!-- <td>{{ h.reference }}</td> -->
      </tr>
    </tbody>
  </table>
</div>


        <p *ngIf="!selectedHistory || selectedHistory.length === 0" class="text-muted">
          No History Available.
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" style="margin-top:20px;position:fixed">Close</button>
      </div>
    </div>
  </div>
</div>
